<template>
    <LinkHover
        :type="'router-link'"
        :to="$trl({
            name: (layout.category === 'project' ||  layout.type === 'project') ? 'Project' : 'Article',
            params: {
                slug: layout.customslug || layout.slug,
                locale: $route.params.locale
            }
        })"
        :classNames="{
            default: 'link-default',
            hover: 'link-hover',
            hoverMask: 'link-hover-mask',
        }"
        :image="layout.image ? layout.image : null"
        class="link project"
    >
        <div class="default">
            <div class="container">
                <div
                    class="tag-container"
                >
                    <span class="tag">{{$t('common.project')}}</span>
                </div>
                <div
                    class="heading"
                >
                    <h3 v-html="layout.name"/>
                </div>
            </div>
            <div class="footer">
                <span class="date">{{layout.date}}</span>
                <IconLink/>
            </div>
        </div>
        <template v-slot:hover>
            <div class="hover">
                <div class="bg-cross-animated"></div>
                <div class="container">
                    <div
                        class="tag-container"
                    >
                        <span class="tag">Réalisation</span>
                    </div>
                    <div
                        class="heading"
                    >
                        <h3 v-html="layout.name"/>
                    </div>
                </div>
                <div class="footer">
                    <span class="date">{{layout.date}}</span>
                    <IconLink/>
                </div>
            </div>
        </template>
    </LinkHover>
</template>

<script>
import IconLink from '@/components/IconLink'
import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        IconLink,
        LinkHover
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
// .board
.container
    flex: 1
.heading
    flex: 0.5648148148
.tag-container
    flex: 0.3

.container
    .tag
        color: #ff2b2a
a
    text-decoration: none
.footer
    .date
        .pictured &
                color: #ffffff
svg
    width: 15px
    height: 15px
    transform: rotate(45deg)
    /deep/ path
        fill: #777b84

.link
    // padding-top: 178px
    // padding-right: 75px
    // padding-bottom: 85px
    // padding-left: 85px
    // @include media-breakpoint-down($sm)
    //     padding-top: 145px
    //     padding-right: 51px
    //     padding-bottom: 69px
    //     padding-left: 69px
    /deep/ .link-default
        display: flex
        flex: 1
        .default
            display: flex
            flex-direction: column
            flex: 1
    /deep/ .link-hover
        background: #ff2b2a
    /deep/ .link-hover-mask
        // padding-top: 178px
        // padding-right: 75px
        // padding-bottom: 85px
        // padding-left: 85px
        .hover
            color: #FFFFFF
            display: flex
            flex-direction: column
            flex: 1
        .container
            .tag
                color: #FFFFFF
        .date
            color: #FFFFFF
        svg
            path
                fill: #FFFFFF
</style>
